import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import PageHeader from "../../Utility/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import { FetchDriverNoWaitingDataList } from "../../redux/vehicleRegistration/FetchDriversData";
import LoadingAnimation from "../../shared/LoadingAnimation";
import NoContentsFound from "../../shared/NoContentsFound";
// import { sendSMS } from "./SendSMS";
import CarTable3 from "./CarTable3";

export default function DriverNoWaitingList() {
  // sendSMS();
  const { t } = useTranslation("translation");
  const data = useSelector((state) => state.vehicle.data);
  const CarsData = useSelector((state) => state.vehicle);
  const loading = useSelector((state) => state.vehicle.loading);
  // const progress = useSelector((state) => state.vehicle.progress);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.authentication.token);

  useEffect(() => {
    dispatch(FetchDriverNoWaitingDataList(token));
  }, []);
  return (
    <div>
      <div className="mt-2">
        <PageHeader title={t("vehicle_details_form.carDetailsRegForm")} />
      </div>
      {loading ? (
        <LoadingAnimation />
      ) : data && data.length>0? (
        <CarTable3 carsData={CarsData} recordType={t("vehicle_details_form.processingVehicleList")} />
      ) : (
        <NoContentsFound message={t("general_key_words.dataNotFound")} />
      )}
    </div>
  );
}
